import { extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import tailwindUi from '@tailwindcss/ui';
import theme from 'tailwindcss/defaultTheme';
import tailwindFilters from 'tailwindcss-filters';
import tailwindMultiline from 'tailwindcss-truncate-multiline';

function aspectRatio(_ref) {
  var addUtilities = _ref.addUtilities;
  addUtilities([{
    '.aspect-ratio': {
      '&::before': {
        content: '""',
        display: 'block',
        height: 0,
        paddingBottom: 'calc(100% / (var(--aspect-ratio)))'
      }
    }
  }]);
} // Logomark animation


var steps = ['12%', '25%', '37%', '50%', '62%', '75%', '87%', '0%, to'];
var colors = ['#2c96d3', '#b068a7', '#d9418c', '#c20e0f', '#f18f00', '#f8d500', '#d2d500', '#7bc9cd'];
var logomarkKeyframes = /*#__PURE__*/Array.from(Array(colors.length)).map(function (_, i) {
  if (i > 0) {
    colors = [colors.pop()].concat(colors);
  }

  return [].concat(colors);
}).reduce(function (obj, c, i) {
  var _Object$assign2;

  return Object.assign(obj, (_Object$assign2 = {}, _Object$assign2["logomark-" + i] = c.reduce(function (frames, hex, x) {
    var _Object$assign;

    return Object.assign(frames, (_Object$assign = {}, _Object$assign[steps[x]] = {
      fill: hex
    }, _Object$assign));
  }, {}), _Object$assign2));
}, {}); // New Logomark animation

var newLogoSteps = ['20%', '40%', '60%', '80%', '0%, to'];
var newLogoColors = ['#ff5200', '#ff6500', '#ff7900', '#ff8c00', '#ff3e00'];
var newLogomarkKeyframes = /*#__PURE__*/Array.from(Array(newLogoColors.length)).map(function (_, i) {
  if (i > 0) {
    newLogoColors = [newLogoColors.pop()].concat(newLogoColors);
  }

  return [].concat(newLogoColors);
}).reduce(function (obj, c, i) {
  var _Object$assign4;

  return Object.assign(obj, (_Object$assign4 = {}, _Object$assign4["new-logomark-" + i] = c.reduce(function (frames, hex, x) {
    var _Object$assign3;

    return Object.assign(frames, (_Object$assign3 = {}, _Object$assign3[newLogoSteps[x]] = {
      fill: hex
    }, _Object$assign3));
  }, {}), _Object$assign4));
}, {});
var config = {
  purge: {
    content: ['./node_modules/@sajari-ui/core/dist/*.js']
  },
  theme: {
    backgroundColor: function backgroundColor(ownTheme) {
      return _extends({}, ownTheme('colors'), {
        hint: '#7c41dd'
      });
    },
    filter: {
      none: 'none',
      'blur-1': 'blur(0.25rem)',
      'blur-2': 'blur(0.5rem)',
      'blur-3': 'blur(0.75rem)',
      'blur-4': 'blur(1rem)',
      'blur-5': 'blur(1.25rem)',
      'blur-6': 'blur(1.5rem)',
      grayscale: 'grayscale(1)',
      invert: 'invert(1)',
      sepia: 'sepia(1)'
    },
    backdropFilter: {
      none: 'none',
      'blur-1': 'blur(0.25rem)',
      'blur-2': 'blur(0.5rem)',
      'blur-3': 'blur(0.75rem)',
      'blur-4': 'blur(1rem)',
      'blur-5': 'blur(1.25rem)',
      'blur-6': 'blur(1.5rem)'
    },
    extend: {
      zIndex: {
        60: 60
      },
      animation: /*#__PURE__*/_extends({}, /*#__PURE__*/Object.keys(logomarkKeyframes).reduce(function (obj, key) {
        var _Object$assign5;

        return Object.assign(obj, (_Object$assign5 = {}, _Object$assign5[key] = key + " 1s ease-in-out infinite", _Object$assign5));
      }, {}), /*#__PURE__*/Object.keys(newLogomarkKeyframes).reduce(function (obj, key) {
        var _Object$assign6;

        return Object.assign(obj, (_Object$assign6 = {}, _Object$assign6[key] = key + " 0.5s ease-in-out infinite", _Object$assign6));
      }, {}), {
        wiggle: 'wiggle 0.35s ease-in-out',
        skeleton: 'skeleton 1s linear infinite',
        'progress-indeterminate': 'progress-indeterminate 3s linear infinite',
        'toast-enter': 'toast-enter 200ms ease-out',
        'toast-leave': 'toast-leave 150ms ease-in forwards'
      }),
      keyframes: /*#__PURE__*/_extends({
        'toast-enter': {
          '0%': {
            transform: 'scale(0.9) translateY(-100%)',
            opacity: 0
          },
          '100%': {
            transform: 'scale(1) translateY(0)',
            opacity: 1
          }
        },
        'toast-leave': {
          '0%': {
            transform: 'scale(1)',
            opacity: 1
          },
          '100%': {
            transform: 'scale(0.9)',
            opacity: 0
          }
        },
        wiggle: {
          '10%': {
            transform: 'translateX(-2px);'
          },
          '30% ': {
            transform: 'translateX(5px);'
          },
          '50%': {
            transform: 'translateX(-5px);'
          },
          '70%': {
            transform: 'translateX(5px);'
          },
          '90%': {
            transform: 'translateX(-2px);'
          },
          '100%': {
            transform: 'translateX(0px);'
          }
        },
        skeleton: {
          from: {
            transform: 'translate(-100%)'
          },
          to: {
            transform: 'translate(100%)'
          }
        },
        'progress-indeterminate': {
          '0%, 100%': {
            transform: 'translate(-100%)'
          },
          '50%': {
            transform: 'translate(400%)'
          }
        }
      }, logomarkKeyframes, newLogomarkKeyframes),
      backgroundColor: {
        inherit: 'inherit'
      },
      borderRadius: {
        inherit: 'inherit',
        xl: '0.75rem',
        '2xl': '1rem',
        '3xl': '1.5rem'
      },
      boxShadow: {
        pressable: theme.boxShadow.sm + ", inset 0 -1px 1px rgba(0, 0, 0, 0.025)",
        border: 'inset 0 0 0 1px rgba(0, 0, 0, 0.075)',
        toast: "0 0 0 1px rgba(0, 0, 0, 0.1), " + theme.boxShadow.lg,
        menu: 'inset 0 0 0 1px rgba(0, 0, 0, 0.1), 0 1px 5px rgba(0, 0, 0, 0.1)'
      },
      inset: {
        '-1': '-0.25rem',
        '-2': '-0.5rem',
        '-3': '-0.75rem',
        '-4': '-1rem',
        '-1/2': '-50%',
        '-1/3': '-33.333333%',
        '-1/4': '-25%'
      },
      colors: {
        current: 'currentColor'
      },
      fontFamily: {
        inherit: 'inherit'
      },
      fontSize: {
        code: '0.8125rem',
        'code-inline': '0.9375em'
      },
      lineHeight: {
        inherit: 'inherit'
      },
      opacity: {
        85: '0.85',
        95: '0.95'
      },
      spacing: {
        '(screen-8)': 'calc(100vh - 2rem)',
        '(screen-12)': 'calc(100vh - 3rem)',
        '(screen-16)': 'calc(100vh - 4rem)',
        '(screen-20)': 'calc(100vh - 5rem)'
      },
      textAlign: {
        inherit: 'inherit'
      }
    },
    fontFamily: /*#__PURE__*/_extends({}, theme.fontFamily, {
      sans: /*#__PURE__*/['"Inter var"'].concat(theme.fontFamily.sans),
      mono: /*#__PURE__*/['"SF Mono"', 'SFMono-Regular', 'ui-monospace'].concat(theme.fontFamily.mono)
    }),
    truncate: {
      lines: {
        2: '2',
        3: '3',
        4: '4',
        5: '5'
      }
    }
  },
  variants: {
    zIndex: ['responsive', 'hover', 'focus'],
    boxShadow: ['responsive', 'hover', 'focus', 'focus-within'],
    textColor: ['responsive', 'hover', 'focus', 'group-hover', 'group-focus'],
    backgroundColor: ['responsive', 'hover', 'focus', 'checked', 'group-hover', 'group-focus', 'odd', 'even'],
    borderColor: ['responsive', 'hover', 'focus', 'checked', 'group-hover', 'group-focus', 'last', 'first', 'odd', 'even'],
    borderWidth: ['responsive', 'hover', 'focus', 'checked', 'group-hover', 'group-focus', 'last', 'first', 'odd', 'even'],
    opacity: ['responsive', 'hover', 'focus', 'group-hover', 'group-focus']
  },
  future: {
    removeDeprecatedGapUtilities: true
  },
  plugins: [tailwindUi, tailwindFilters, tailwindMultiline, aspectRatio]
};

export default config;
//# sourceMappingURL=tailwind.config.esm.js.map
